<template>
  <div>
    <el-row>
      <div>
        <template>
          <!--动态将图片轮播图的容器高度设置成与图片一致-->
          <el-carousel :interval="4000" type="card" :height="bannerHeight+'px'">
            <el-carousel-item v-for="item in imgUrls" :key="item.id">
              <el-row>
                <el-col :span="24" class="banner_img">
                  <img
                    ref="bannerHeight"
                    :src="item.idView"
                    class="bannerImg"
                    @load="imgLoad"
                    style="width: 100%;height: 100%"
                  />
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
    </el-row>

    <el-row>
      <div style="text-align: left;margin-left: 10%">
        <h3 style="font-size: 400%;">加入我们</h3>


        <p style="font-size: 150%">如果说，公司是一艘大船，你就是稳航的船员， 我们衷心希望，你可以不惧风浪与挑战，与腾盛一起奋力向前。</p>
        <p style="font-size: 150%">我们也衷心期望，你在腾盛能有新的收获，为你的职业生涯增添新的精彩！</p>
        <br />


        <p style="font-size: 250%; font-style: italic;">
          在招热门岗位&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span
            style="font-size: 20px;opacity:0.65"
          >(了解更多详情请登录猎聘网、拉勾网，搜索 “ 腾盛 ” 了解更多详情)</span>
        </p>

        <p
          style="font-size: 150%;font-style: italic;"
        >产品经理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广东.深圳</p>

        <p
          style="font-size: 150%;font-style: italic;"
        >java开发工程师&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广东.深圳</p>

        <p
          style="font-size: 150%;font-style: italic;"
        >测试工程师&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广东.深圳</p>
        <br />
        <br />
        <hr style="margin-right: 330px;opacity:0.15" />
        <br />


        <p style="font-size: 250%;font-style: italic;">招聘通道</p>

        <div class="div-inline">
          <p
            style="font-size: 150%;font-style: italic;"
          >招聘热线&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0755-66682776</p>
          <br /><br>
          <p
            style="font-size: 150%;font-style: italic;"
          >招聘邮箱&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;recruit@gdbbk.com</p>
        </div>

        <div class="div-inline" style="margin-left: 100px">

          <img src="../../assets/img/bg/lagou.png" style="width:90px;height:90px"/>
          <p style="text-align: center;margin-top:2px">拉勾网</p>
        </div>
        <div class="div-inline" style="margin-left: 50px">

          <img src="../../assets/img/bg/liepin.png" style="width:90px;height:90px"/>
          <p style="text-align: center;margin-top:2px">猎聘网</p>
        </div>
        <!-- <p style="margin-left: 600px;margin-top: -15px;opacity:0.65">扫一扫了解更多详情</p> -->
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerHeight: "",
      imgUrls: [
        { id: 0, idView: require("../../assets/img/head/head1.jpg") },
        { id: 1, idView: require("../../assets/img/head/head2.jpg") },
        { id: 2, idView: require("../../assets/img/test/join2.jpeg") },
        { id: 3, idView: require("../../assets/img/test/join1.jpg") },
      ],
    };
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
        console.log(this.$refs.bannerHeight[0].height);
      });
    },
    mounted() {
      this.imgLoad();
      window.addEventListener(
        "resize",
        () => {
          this.bannerHeight = this.$refs.bannerHeight[0].height;
          this.imgLoad();
        },
        false
      );
    },
  },
};
</script>
<style>
.div-inline {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/join/JoinUs.vue